import { render, staticRenderFns } from "./RadioTypeCheck.vue?vue&type=template&id=58aa4ebe&scoped=true"
import script from "./RadioTypeCheck.vue?vue&type=script&lang=js"
export * from "./RadioTypeCheck.vue?vue&type=script&lang=js"
import style0 from "./RadioTypeCheck.vue?vue&type=style&index=0&id=58aa4ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa4ebe",
  null
  
)

export default component.exports